export type ResolvedDeviceOperation = {
  data: string | undefined;
  error: string | undefined;
  inProgress: boolean;
  found: boolean;
};

type OperationLike = {
  data?: string;
  error?: string;
  by_weld_uid?: Record<string, { data?: string; error?: string }>;
} | null | undefined;

/**
 * Resolve get_time / set_time / location / etc. for a command.
 * - If by_weld_uid[weldUID] exists → use that entry (manual multi-machine).
 * - If by_weld_uid has other keys but not this UID → keep waiting (do not steal sibling data).
 * - Otherwise → top-level fields (M500 / P625 / coating / legacy manual).
 */
export function resolveOperationForWeldUid(
  operation: OperationLike,
  weldUID?: string | null
): ResolvedDeviceOperation {
  if (!operation) {
    return { data: undefined, error: undefined, inProgress: false, found: false };
  }

  const byUid = operation.by_weld_uid;
  if (weldUID && byUid && typeof byUid === 'object' && !Array.isArray(byUid)) {
    const entry = byUid[weldUID];
    if (entry) {
      return {
        data: entry.data,
        error: entry.error,
        inProgress: entry.data === 'In Progress',
        found: true,
      };
    }

    // Non-empty map means multi-machine responses are active — wait for this UID
    if (Object.keys(byUid).length > 0) {
      return {
        data: undefined,
        error: undefined,
        inProgress: true,
        found: false,
      };
    }
  }

  // Legacy / other weld types (no by_weld_uid, or empty map)
  return {
    data: operation.data,
    error: operation.error,
    inProgress: operation.data === 'In Progress',
    found: true,
  };
}
